'use client'

import { useState } from 'react'
import { useAuthStore } from '@/lib/stores/useAuthStore'
import { useUIStore } from '@/lib/stores/useUIStore'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Alert, AlertDescription } from '@/components/ui/alert'

export function CreatorUpgradeModal() {
  const { isCreatorUpgradeModalOpen, closeCreatorUpgradeModal } = useUIStore()
  const { profile, upgradeToCreator, error, clearError, isLoading } = useAuthStore()
  const [success, setSuccess] = useState(false)

  const handleUpgrade = async () => {
    try {
      await upgradeToCreator()
      setSuccess(true)
      
      // Close modal after 2 seconds on success
      setTimeout(() => {
        closeCreatorUpgradeModal()
        setSuccess(false)
      }, 2000)
    } catch (err) {
      console.error('Error upgrading to creator:', err)
    }
  }

  const onOpenChange = (open: boolean) => {
    if (!open) {
      closeCreatorUpgradeModal()
      clearError()
      setSuccess(false)
    }
  }

  return (
    <Dialog open={isCreatorUpgradeModalOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Become a Creator</DialogTitle>
          <DialogDescription>
            Upgrade your account to creator status to start sharing your insights and analysis with the community.
          </DialogDescription>
        </DialogHeader>

        {error && (
          <Alert variant="destructive">
            <AlertDescription>{error}</AlertDescription>
          </Alert>
        )}

        {success && (
          <Alert>
            <AlertDescription>
              Congratulations! You are now a creator. You can start creating content for the community.
            </AlertDescription>
          </Alert>
        )}

        {profile?.role === 'creator' ? (
          <div className="py-4">
            <p className="text-center">You are already a creator!</p>
          </div>
        ) : (
          <div className="py-4">
            <p className="mb-4">
              As a creator, you&apos;ll be able to:
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Create and publish content</li>
              <li>Build your following</li>
              <li>Share your crypto insights and analysis</li>
            </ul>
          </div>
        )}

        <DialogFooter>
          {profile?.role !== 'creator' && !success && (
            <Button onClick={handleUpgrade} disabled={isLoading}>
              {isLoading ? 'Upgrading...' : 'Become a Creator'}
            </Button>
          )}
          <Button variant="outline" onClick={closeCreatorUpgradeModal}>
            {profile?.role === 'creator' || success ? 'Close' : 'Cancel'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
} 